import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { store } from '@/store';
import { getDesignTokens } from '@/utils/theme';
import CloseIcon from '@mui/icons-material/Close';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import App from './App';

import 'react-toastify/dist/ReactToastify.min.css';
import '@/notify.css';
import '@/CustomTooltip.css';
import './index.css';

const IndexPage = () => {
  const [mode, setMode] = React.useState('light');

  const themeDante = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode]);
  const helmetContext = {};

  const CloseButton = ({ closeToast }) => (
    <i className="material-icons" style={{ color: 'white' }} onClick={closeToast}>
      <CloseIcon fontSize="small" sx={{ color: 'white', cursor: 'pointer' }} />
    </i>
  );

  return (
    <React.StrictMode>
      <ThemeProvider theme={themeDante}>
        <CssBaseline />
        <HelmetProvider context={helmetContext}>
          <Provider store={store}>
            <App />
            <ToastContainer closeButton={CloseButton} />
          </Provider>
        </HelmetProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
};

createRoot(document.getElementById('root')).render(<IndexPage />);
